export default __webpack_public_path__ + "static/media/optimistic_ethereum.6510cce8.svg";